/**
 * Generated bundle index. Do not edit.
 */

export {NgxDygraphsComponent,NgxDygraphsModule} from './index';
